import { ApolloError, useMutation } from '@apollo/client'
import { InsertContentItemsFromHtml } from 'api/graphQL/mutations/contentInsert.mutations'
import {
    InsertContentItemsFromHtmlInput,
    InsertContentItemsFromHtmlResponse,
} from 'api/graphQL/types/contentInsert.types'
import { handleFetchError } from 'components/WorkspaceEditor/api/utils'

export const usePasteContentItemsFromHtmlMutation = (
    onCompleted?: (data: InsertContentItemsFromHtmlResponse) => void,
    onError?: (error: ApolloError) => void
) => {
    const [pasteContentItemsFromHtml, { loading, error, data }] = useMutation<
        InsertContentItemsFromHtmlResponse,
        {
            input: Partial<InsertContentItemsFromHtmlInput>
            partType: string
            productFamilyId: string
            rootArticleContentItemIds: string[]
        }
    >(InsertContentItemsFromHtml, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            if (onCompleted) onCompleted(data)
        },
        onError: (error: ApolloError) => {
            handleFetchError(error, 'Failed to paste content items from HTML')
            if (onError) onError(error)
        },
    })

    return { pasteContentItemsFromHtml, loading, error, data }
}
